import type { ComponentProps } from "react"

export default function IndustryM(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M29.6706 9.86676L28.8253 10.7121C28.792 10.7441 28.7546 10.7708 28.7213 10.8028L21.1906 3.27876C21.2239 3.24543 21.2506 3.20676 21.2826 3.17476L22.128 2.32943L20.2413 0.444092L19.3973 1.28943C17.6814 3.00976 16.3549 5.07856 15.5077 7.35587C14.6605 9.63318 14.3123 12.0659 14.4866 14.4894C12.0632 14.3149 9.63053 14.663 7.35323 15.5099C5.07592 16.3569 3.00707 17.6831 1.28662 19.3988L0.441284 20.2454L2.32928 22.1334L3.17462 21.2868C3.20795 21.2548 3.24528 21.2281 3.27862 21.1961L10.8093 28.7268C10.776 28.7588 10.7506 28.7974 10.7173 28.8294L9.87195 29.6748L11.7573 31.5601L12.6026 30.7148C14.3187 28.9946 15.6453 26.9258 16.4925 24.6485C17.3398 22.3711 17.6879 19.9383 17.5133 17.5148C19.9369 17.6899 22.3699 17.3421 24.6473 16.4949C26.9247 15.6476 28.9935 14.3207 30.7133 12.6041L31.5586 11.7588L29.6706 9.86676ZM26.628 12.4801C25.8532 12.9974 25.0297 13.4377 24.1693 13.7948L18.1999 7.82943C18.5563 6.96931 18.9961 6.14625 19.5133 5.37209L26.628 12.4801ZM14.7999 17.2001C14.9495 18.5551 14.9046 19.9245 14.6666 21.2668L10.7319 17.3334C12.0747 17.0953 13.4445 17.0504 14.7999 17.2001ZM5.37328 19.5134C6.14727 18.9956 6.97035 18.5553 7.83062 18.1988L13.8013 24.1694C13.4448 25.0301 13.0044 25.8536 12.4866 26.6281L5.37328 19.5134ZM17.1999 14.8001C17.0497 13.4451 17.0946 12.0756 17.3333 10.7334L21.2666 14.6668C19.9243 14.9043 18.555 14.9492 17.1999 14.8001Z"
        fill={fill}
      />
    </svg>
  )
}
